'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _indexCommon = require('./index.common');

var _indexCommon2 = _interopRequireDefault(_indexCommon);

exports['default'] = _indexCommon2['default'];
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./index.js
 **/